export default __webpack_public_path__ + "static/media/identity-font-desc.d08e54e1.png";